
module dgUtils {

    function isEmpty(propValue) { 
        return propValue == null || propValue === '' || (angular.isArray(propValue) && propValue.length == 0); //TODO: Is this correct? );
    }

    function isEmptyProp(): Function {
        return propValue => isEmpty(propValue);
    }
    function isNotEmptyProp(): Function {
        return propValue => !isEmpty(propValue);
    }

    angular.module('dgUtils')
        .filter('isEmptyProp', isEmptyProp)
        .filter('isNotEmptyProp', isNotEmptyProp);
}